import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo";
import { RegionPage } from "@/components/calv/RegionPage";

export const Route = createFileRoute("/regionen/nuernberg")({
  head: () => {
    const h = pageHead("region:nuernberg", "de");
    return { meta: h.meta, links: h.links };
  },
  component: () => <RegionPage slug="nuernberg" locale="de" />,
});
